// extracted by mini-css-extract-plugin
export var contest = "contest-module--contest--59753";
export var description = "contest-module--description--a4d58";
export var details = "contest-module--details--86b31";
export var image = "contest-module--image--50aaa";
export var image__desktop = "contest-module--image__desktop--bc699";
export var image__mobile = "contest-module--image__mobile--c337e";
export var logo = "contest-module--logo--20243";
export var spin = "contest-module--spin--aceff";